export default "__VITE_PUBLIC_ASSET__79c3bea0__"